import { InputAdornment, TextField } from "@mui/material";
import logo from "../../images/logo.svg";
import { useDebouncedCallback } from "use-debounce";
import { MapY } from "./components";
import {
  Header,
  LogoWrapper,
  SearchingItemsWrapper,
  SearchItem,
  SearchWrapper,
} from "./styles";
import { Search } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setAddress, setHideLogo } from "./store";
import { useEffect, useState } from "react";
import { getQueryParams } from "utils/helpers/getQueryParams";
import { IGlobalParamsSearch } from "./store/types";
import { mapSelector } from "./store/selectors";

export const MapPage = () => {
  const dispatch = useDispatch();

  const { hide_logo } = useSelector(mapSelector);
  console.log('useSelector(mapSelector)', hide_logo);
  

  const [inpValue, setInpValue] = useState<string>("");
  const [searchingAddresses, setSearchingAddresses] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const getAddress = async (value: string) => {
    const response = await fetch(
      `${process.env.REACT_APP_API}/${process.env.REACT_APP_API_VERSION}/suggestions/address?address=${value}`,
      {
        method: "get",
        headers: {
          accept: "application/json",
          "Content-type": "application/json",
          "x-request-id": "123",
          "x-service-name": "123",
        },
      },
    );
    const json = await response.json();

    setSearchingAddresses(json?.items);
    setIsOpen(true);
  };

  const debounced = useDebouncedCallback((value) => getAddress(value), 800);

  useEffect(() => {
    if (!inpValue) return;

    debounced(inpValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inpValue]);

  useEffect(() => {
    const search = window.location.href.split('?')[1];
    if (!search) return;
    const queriesObj = getQueryParams(search) as IGlobalParamsSearch;

    if (queriesObj !== undefined && queriesObj !== null) {
      dispatch(setHideLogo(true));
    } else {
      dispatch(setHideLogo(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  return (
    <div style={{ position: "relative" }}>
      <Header>
        {!hide_logo ? <LogoWrapper>
          <img src={logo} alt="logo" />
        </LogoWrapper> : null}
        <SearchWrapper>
          <TextField
            fullWidth
            placeholder="Поиск на карте"
            variant="outlined"
            size="small"
            value={inpValue}
            onChange={(e) => setInpValue(e.target.value)}
            onFocus={(e) => {
              if (!e.target.value) return;
              getAddress(e.target.value);
            }}
            onBlur={() => {
              setInpValue("");
              setTimeout(() => {
                setIsOpen(false);
              }, 200);
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              },
            }}
          />
          {isOpen ? (
            <SearchingItemsWrapper>
              {searchingAddresses?.length ? (
                searchingAddresses?.map((item: any, i: number) => {
                  return (
                    <SearchItem
                      key={i}
                      onClick={() => {
                        dispatch(setAddress([item?.long, item?.lat]));
                        setIsOpen(false);
                      }}
                    >
                      {item?.name}
                    </SearchItem>
                  );
                })
              ) : (
                <SearchItem>Ничего не найдено</SearchItem>
              )}
            </SearchingItemsWrapper>
          ) : null}
        </SearchWrapper>
      </Header>
      <MapY />
    </div>
  );
};
